import React from 'react'
import { Button, Col, Image, Row } from 'react-bootstrap'
import { Link, useHistory } from 'react-router-dom'

export default function HeaderPublic() {
    const history = useHistory();
  return (
    <header className='d-block'>
        <Row className="w-100 m-0">
            <Col className="col-5 d-flex align-items-center">
                <Link to="/">
                    <Image
                        alt="Influence vision logo"
                        src="/tempAssets/influence-vision-logo.svg"
                        height={60}
                        width={150}
                    />
                </Link>
            </Col>
            <Col
                className="col-7 d-flex align-items-center justify-content-end ml-auto"
            >
                <Button variant='outline-primary' onClick={() => history.push('/')}>Sign in</Button>
            </Col>
        </Row>
    </header>
  )
}
